// extracted by mini-css-extract-plugin
module.exports = {"container":"AppNewsEdition_container__3p8k8","sectionSeparator":"AppNewsEdition_sectionSeparator__2YwfC"};